import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState, WorkType } from './types'
import { ProfileType } from '../SignInPage/types'
import moment from 'moment'
import { declOfNum, getFormatFromUrl } from '../../utils/helpers'
import translitRusEng from 'translit-rus-eng'
import $ from 'jquery'
import Slider from 'react-slick'
import { AttachmentItemType } from '../ProfileContestsWorkPage/types'
import VideoPlayer from '@famiryru/react-famiry-video-player'

// Styles
import './styles.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import Loading from '../../components/Loading'
import ModalCriteries from '../../components/ModalCriteries'
import ExpertFilesBlock from '../../components/ExpertFilesBlock'
import ExpertGalleryBlock from '../../components/ExpertGalleryBlock'

// Icons
import IconBook from './images/iconBook'
import IconPrev from './images/iconPrev'
import IconNext from './images/iconNext'
import IconLeaf from './images/iconLeaf'
import IconChange from './images/iconChange'
import IconArrowPrev from './images/iconArrowPrev'
import IconArrowNext from './images/iconArrowNext'

const {
  REACT_APP_CABINET_EXPERT_INSTRUCTION,
  REACT_APP_NOMINATION_PHOTOS,
  REACT_APP_NOMINATION_CHRONICLE,
  REACT_APP_NOMINATION_PRESENTATION,
  REACT_APP_NOMINATION_FAMILY_TREE,
  REACT_APP_NOMINATION_VIDEOS,
  REACT_APP_NOMINATION_PODCASTS,
} = process.env

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <IconArrowNext />,
  prevArrow: <IconArrowPrev />,
}

const imageFormats = ['bmp', 'jpg', 'jpeg', 'gif', 'png']

const mediaFormats = ['m4a', 'mp3', 'wav', 'mp4', '3gp', 'ogg', 'webm']

const ContentHeader = ({ work }: { work: WorkType }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0)

  switch (work.nomination_id) {
    case REACT_APP_NOMINATION_PHOTOS:
      const firstPhoto = work.attachments.find(item =>
        imageFormats.includes(getFormatFromUrl(item.url))
      )
      return (
        <div className={'content'}>
          <div className={'content__title'}>{work.title}</div>
          {firstPhoto ? (
            <div className={'content__media'}>
              <div className={'content__image'}>
                <a data-fancybox href={firstPhoto.url} className={'item'}>
                  <img src={firstPhoto.url} />
                </a>
              </div>
            </div>
          ) : null}
        </div>
      )
    case REACT_APP_NOMINATION_VIDEOS:
    case REACT_APP_NOMINATION_PODCASTS:
      const media = work.attachments
        .filter(item => mediaFormats.includes(getFormatFromUrl(item.url)))
        .map(item => item.url)
      return (
        <div className={'content'}>
          <div className={'content__title'}>{work.title}</div>
          {media && media.length ? (
            <div className={'content__media'}>
              <Slider {...settings} afterChange={setCurrentSlide}>
                {media.map((item, index) => (
                  <VideoPlayer
                    containerStyle={{
                      height: 426,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                    }}
                    width={'auto'}
                    height={426}
                    url={item}
                    key={`media-${index}`}
                    toggleStop={`toggle-${currentSlide}`}
                  />
                ))}
              </Slider>
            </div>
          ) : null}
        </div>
      )
    default:
      return (
        <div className={'content'}>
          <div className={'content__title'}>{work.title}</div>
        </div>
      )
  }
}

export default () => {
  const [downloadProgressFiles, setDownloadProgressFiles] = useState<
    { file_id: string; percent: number }[]
  >([])
  const [modalCriteries, setModalCriteries] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [isCriteriesChanges, setIsCriteriesChanged] = useState<boolean>(false)

  const dispatch = useDispatch()

  const isMounted = useRef<boolean>(false)
  const isLoaded = useRef<boolean>(false)
  const isNewCrtiteries = useRef<boolean>(false)
  const refContestWrapper = useRef<HTMLDivElement | null>(null)

  const optionRefs = useRef<Array<HTMLDivElement | null>>([])

  const {
    work,
    meta,
    criteries,
    isFetchingWork,
    isProcessSendReview,
    isFetchingCriteries,
    error,
  } = useSelector(
    (state: { profileExpertCabinet: InitialState }) =>
      state.profileExpertCabinet
  )

  const downloadIsProcess = downloadProgressFiles.some(
    file => file.percent < 100
  )
  const isViewedWork = work && work.currentExpertReview
  const canEdited = work && work.currentExpertReview?.can_edit
  const totalPoints = criteries.reduce(
    (previousValue, item) =>
      item.value ? item.value + previousValue : previousValue,
    0
  )

  const onClickOutside = (e: any) => {
    if (
      !$(e.target).parents('.option__values-item').length &&
      !optionRefs.current.includes(e.target)
    ) {
      $('.option').removeClass('opened')
    }
  }

  const scrollToContestWrapper = () => {
    if (refContestWrapper.current) {
      const offsetTop = ($(refContestWrapper.current).offset()?.top || 0) - 20
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: offsetTop,
        },
        300
      )
    }
  }

  useEffect(() => {
    if (work && isMounted.current) {
      dispatch(actions.fetchCriteries(work.contest_id, work.nomination_id))
      isNewCrtiteries.current = true
      setIsCriteriesChanged(false)
      setIsEdit(false)
      if (isLoaded.current) {
        scrollToContestWrapper()
      } else {
        isLoaded.current = true
      }
    }
  }, [work])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchRandomWork())
    isMounted.current = true
    window.addEventListener('click', onClickOutside)
    return () => {
      dispatch(actions.destroy())
      window.removeEventListener('click', onClickOutside)
    }
  }, [])

  useEffect(() => {
    if (
      criteries.length &&
      isViewedWork &&
      work &&
      work.currentExpertReview &&
      isNewCrtiteries.current
    ) {
      isNewCrtiteries.current = false
      work.currentExpertReview.criteria.forEach(item => {
        dispatch(
          actions.setCriteriaParam(
            item.criterion.criterion_id,
            'value',
            item.point_value
          )
        )
      })
    }
  }, [criteries])

  const getProfileInfo = (
    profile: ProfileType,
    type: string
  ): string | JSX.Element => {
    switch (type) {
      case 'fio':
        const wrapFio = []
        if (profile.profile.last_name) {
          wrapFio.push(profile.profile.last_name)
        }
        if (profile.profile.first_name) {
          wrapFio.push(profile.profile.first_name)
        }
        if (profile.profile.middle_name) {
          wrapFio.push(profile.profile.middle_name)
        }
        return wrapFio.join(' ')
      case 'age':
        const diffAge = moment().diff(profile.profile?.birthdate, 'years')
        return diffAge ? (
          <div className={'info__row-age'}>
            {diffAge} {declOfNum(diffAge, ['год', 'года', 'лет'])}
          </div>
        ) : (
          ''
        )
      case 'id':
        return profile.profile.short_id || ''
      default:
        return ''
    }
  }

  const getAnswerField = (code: string): string => {
    if (work) {
      const value = work.answers.find(
        answer => answer.contest_field.code === code
      )?.value
      if (value) return value
    }
    return ''
  }

  const handleDownload = (file_id: string, url: string, name: string): void => {
    const downloadProgress = (file_id: string, percent: number) => {
      setDownloadProgressFiles(prev => {
        let modifyPrev
        if (prev.some(file => file.file_id === file_id)) {
          modifyPrev = [...prev].map(file =>
            file.file_id === file_id
              ? {
                  ...file,
                  percent,
                }
              : file
          )
        } else {
          modifyPrev = [...prev, { file_id, percent }]
        }
        return [...modifyPrev]
      })
    }

    const fio = work ? getProfileInfo(work.user, 'fio') : ''
    const format = url.split('.').pop()
    const id = work ? getProfileInfo(work.user, 'id') : ''
    const formatName = translitRusEng(
      `${fio} ${id} ${name.replace(/\.[^/.]+$/, '')}.${format}`,
      { slug: true }
    )

    dispatch(actions.downloadFile(file_id, url, formatName, downloadProgress))
  }

  const handleDownloadAll = (): void => {
    if (work) {
      work.attachments.forEach(attachment =>
        handleDownload(attachment.uuid, attachment.url, attachment.name)
      )
    }
  }

  const handleSendReview = () => {
    if (isEdit && !isCriteriesChanges) {
      setIsEdit(false)
    } else {
      if (work && criteries) {
        const criteriesData: { criterion_id: string; point_value?: number }[] =
          []
        criteries
          .filter(item => item.value !== undefined)
          .forEach(item =>
            criteriesData.push({
              criterion_id: item.criterion_id,
              point_value: item.value,
            })
          )
        dispatch(
          actions.sendWorkReview(
            work.user_contest_id,
            criteriesData,
            isViewedWork
          )
        )
      }
    }
  }

  const handleOpenOption = (index: number) => {
    if (optionRefs.current[index]) {
      $('.option').removeClass('opened')
      // @ts-ignore
      $(optionRefs.current[index]).addClass('opened')
    }
  }

  const setOptionValue = (id: string, value: number) => {
    dispatch(actions.setCriteriaParam(id, 'value', value))
    setIsCriteriesChanged(true)
    setTimeout(() => $('.option').removeClass('opened'))
  }

  const fetchWork = (work_id: string | null) => {
    if (work_id) {
      window.scrollTo({ top: 0, left: 0 })
      dispatch(actions.fetchWork(work_id))
    }
  }

  const Content = ({
    files,
    gallery,
    description,
  }: {
    files?: AttachmentItemType[]
    gallery?: string[]
    description?: string
  }) => {
    return (
      <>
        {files && files.length ? (
          <ExpertFilesBlock
            files={files}
            downloadProgressFiles={downloadProgressFiles}
            downloadIsProcess={downloadIsProcess}
            handleDownloadAll={handleDownloadAll}
            handleDownload={handleDownload}
          />
        ) : null}
        {gallery && gallery.length ? (
          <ExpertGalleryBlock gallery={gallery} />
        ) : null}
        {description ? <div className={'essence'}>{description}</div> : null}
      </>
    )
  }

  const NominationContent = () => {
    if (!work) return <></>

    switch (work.nomination_id) {
      case REACT_APP_NOMINATION_PHOTOS:
        const firstPhoto = work.attachments.find(item =>
          imageFormats.includes(getFormatFromUrl(item.url))
        )
        return (
          <Content
            files={work.attachments.filter(item =>
              firstPhoto ? item.uuid !== firstPhoto.uuid : true
            )}
          />
        )
      case REACT_APP_NOMINATION_CHRONICLE:
        return (
          <Content
            files={work.attachments.filter(
              item => !imageFormats.includes(getFormatFromUrl(item.url))
            )}
            gallery={work.attachments
              .filter(item => imageFormats.includes(getFormatFromUrl(item.url)))
              .map(item => item.url)}
            description={getAnswerField('essence')}
          />
        )
      case REACT_APP_NOMINATION_PRESENTATION:
        return (
          <Content
            files={work.attachments}
            description={getAnswerField('essence')}
          />
        )
      case REACT_APP_NOMINATION_FAMILY_TREE:
        return (
          <Content
            files={work.attachments.filter(
              item => !imageFormats.includes(getFormatFromUrl(item.url))
            )}
            gallery={work.attachments
              .filter(item => imageFormats.includes(getFormatFromUrl(item.url)))
              .map(item => item.url)}
            description={getAnswerField('essence')}
          />
        )
      case REACT_APP_NOMINATION_VIDEOS:
        return (
          <Content
            files={work.attachments}
            description={getAnswerField('essence')}
          />
        )
      case REACT_APP_NOMINATION_PODCASTS:
        return (
          <Content
            files={work.attachments.filter(
              item => !imageFormats.includes(getFormatFromUrl(item.url))
            )}
            gallery={work.attachments
              .filter(item => imageFormats.includes(getFormatFromUrl(item.url)))
              .map(item => item.url)}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <div className={'expert-cabinet'}>
      <Header />
      <div className={'container'}>
        <ProfileHeader style={{ marginBottom: 42 }} />
        {isFetchingWork || !isMounted.current ? (
          <LoadingPage />
        ) : work ? (
          <div ref={refContestWrapper}>
            <div className={'profile__leaf'} style={{ marginTop: -40 }}>
              <IconLeaf />
            </div>
            <div className={'expert-cabinet__header'}>
              <div className={'expert-cabinet__header-left'}>
                <div className={'role'}>Ученик</div>
                <div className={'info'}>
                  <span className={'info__name'}>
                    {getProfileInfo(work.user, 'fio')}
                  </span>
                  <div className={'info__row'}>
                    {getProfileInfo(work.user, 'age')}
                    <div className={'info__row-id'}>
                      ID {getProfileInfo(work.user, 'id')}
                    </div>
                  </div>
                </div>
              </div>
              <div className={'expert-cabinet__header-right'}>
                <IconBook />
                <div className={'available'}>
                  Доступно для
                  <br />
                  оценки работ
                </div>
                <div className={'count'}>
                  {meta ? meta.unreviewed_count : 0}
                </div>
              </div>
            </div>
            <div className={'expert-cabinet__main'}>
              <div className={'expert-cabinet__main-left'}>
                <div className={'nomination'}>
                  <div className={'nomination__label'}>Номинация</div>
                  <div className={'nomination__input'}>
                    <span>{work.nomination.caption}</span>
                  </div>
                  <div className={'nomination__label'}>Возрастная группа</div>
                  <div className={'nomination__input'}>
                    <span>{work.age_category.caption}</span>
                  </div>
                </div>
                <div className={'calculator'}>
                  <div className={'calculator__scores'}>
                    <div className={'calculator__scores-total'}>
                      <div className={'value'}>{totalPoints}</div>
                      Сумма
                      <br />
                      балов
                    </div>
                    <button
                      disabled={!canEdited}
                      className={'calculator__scores-button'}
                      onClick={() => setIsEdit(!isEdit)}
                    >
                      <IconChange style={{ marginRight: 17 }} />{' '}
                      <span>Изменить баллы</span>
                    </button>
                  </div>
                  <div className={'calculator__criteries'}>
                    {isFetchingCriteries ? (
                      <Loading color={'#1978B2'} style={{ marginBottom: 50 }} />
                    ) : (
                      criteries.map((item, index) => (
                        <div
                          key={item.criterion_id}
                          className={'calculator__criteries-item'}
                        >
                          <span>{item.caption}</span>
                          <div
                            onClick={() =>
                              isViewedWork && !isEdit
                                ? null
                                : handleOpenOption(index)
                            }
                            className={
                              isViewedWork && !isEdit
                                ? 'option disabled'
                                : 'option'
                            }
                            style={!item.value ? { background: '#DBDBDB' } : {}}
                            ref={ref => (optionRefs.current[index] = ref)}
                          >
                            <span>{item.value || 0} б.</span>
                            <div
                              className={
                                isViewedWork
                                  ? 'option__values viewed'
                                  : 'option__values'
                              }
                            >
                              {[
                                ...new Array(
                                  item.max_points - item.min_points + 1
                                ),
                              ].map((_, index) => {
                                const value = item.min_points + index
                                return (
                                  <div
                                    key={`option-${index}`}
                                    onClick={() =>
                                      setOptionValue(item.criterion_id, value)
                                    }
                                    className={
                                      item.value === value ||
                                      (!item.value && !index)
                                        ? 'option__values-item active'
                                        : 'option__values-item'
                                    }
                                  >
                                    <span>{value} б.</span>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                    <button
                      onClick={() => setModalCriteries(true)}
                      className={'calculator__criteries-all'}
                    >
                      Критерии
                    </button>
                    <a
                      href={REACT_APP_CABINET_EXPERT_INSTRUCTION}
                      target={'_blank'}
                      className={'calculator__criteries-instruction'}
                      rel="noreferrer"
                    >
                      Посмотреть инструкцию
                    </a>
                  </div>
                </div>
              </div>
              <div className={'expert-cabinet__main-right'}>
                <ContentHeader work={work} />
                <NominationContent />
              </div>
            </div>
            <div className={'expert-cabinet__buttons'}>
              <div className={'expert-cabinet__buttons-item'}>
                <button
                  disabled={(meta && !meta.previous) || isEdit}
                  className={'button'}
                  onClick={() => (meta ? fetchWork(meta.previous) : null)}
                >
                  <IconPrev className={'icon'} />
                </button>
              </div>
              <div className={'expert-cabinet__buttons-item'}>
                <button
                  disabled={
                    isProcessSendReview ||
                    isFetchingCriteries ||
                    !!(isViewedWork && !isEdit)
                  }
                  onClick={handleSendReview}
                  className={'button'}
                >
                  {isProcessSendReview ? (
                    <Loading
                      style={{ margin: '0 0 4px' }}
                      width={50}
                      height={50}
                      color={'#FFF'}
                    />
                  ) : (
                    'Выставить баллы'
                  )}
                </button>
              </div>
              <div className={'expert-cabinet__buttons-item'}>
                <button
                  disabled={(meta && !meta.next) || isEdit}
                  onClick={() => (meta ? fetchWork(meta.next) : null)}
                  className={'button'}
                >
                  <IconNext className={'icon'} />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={'profile__leaf'} style={{ marginTop: -40 }}>
              <IconLeaf />
            </div>
            <div className={'expert-cabinet__no-work'}>
              Нет доступных
              <br />
              для оценки работ
              {meta && meta.previous ? (
                <button
                  className={'back'}
                  onClick={() => fetchWork(meta.previous)}
                >
                  <span>{'<'}</span>
                  Вернуться к проверенным работам
                </button>
              ) : null}
            </div>
          </>
        )}
        {error ? <p style={{ color: 'red' }}>{error}</p> : null}
      </div>
      <ModalCriteries
        modal={modalCriteries}
        criteries={criteries}
        onClose={() => setModalCriteries(false)}
      />
      <Footer />
    </div>
  )
}
